import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    borderBottom: '2px solid #F1F1F1',
    boxSizing: 'border-box',

    '&:focus-within': {
      borderBottomColor: 'black'
    },

    '& .text': {
      width: '100%',
      opacity: '0.7'
    },

    '& .adorn': {
      marginRight: '10px'
    }
  },

  input: {
    flex: '1'
  }
}))

export default useStyles
